import { TablePaginationProps } from '@mui/material'
import {
  GridPagination,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { useMemo } from 'react'
import { PaginationLabel } from './PaginationLabel'

interface CustomPaginationProps {
  totalCountLoading: boolean
  totalCountIsApprox?: boolean
}

export const CustomPagination: React.FC<CustomPaginationProps> = ({ totalCountLoading, totalCountIsApprox = false }) => {
  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)

  const paginationModel = apiRef.current.state.pagination?.paginationModel
  const stateRowCount = apiRef.current.state.pagination?.rowCount
  const rowCount = stateRowCount ?? 0

  const labelDisplayedRows = useMemo<TablePaginationProps['labelDisplayedRows']>(() => {
    const Label: NonNullable<TablePaginationProps['labelDisplayedRows']> = ({ from, to, count, page }) => (
      <PaginationLabel
        from={from}
        to={to}
        count={count}
        page={page}
        totalCountLoading={totalCountLoading}
        totalCountIsApprox={totalCountIsApprox}
      />
    )
    return Label
  }, [totalCountLoading, totalCountIsApprox])

  if (isNil(paginationModel)) {
    return <GridPagination />
  }

  return (
    <GridPagination
      slotProps={{
        actions: {
          ...(totalCountLoading && {
            previousButton: {
              disabled: page === 0,
            },
            nextButton: {
              disabled: page >= pageCount - 1 || rowCount === 0,
            },
          }),
        },
      }}
      labelDisplayedRows={labelDisplayedRows}
      {...(stateRowCount == null && { count: -1 })}
    />
  )
}
